// extracted by mini-css-extract-plugin
module.exports = {"container":"SpinnerBox_container__3nFiE"};